import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { AttachMoney, EventRepeat, HourglassEmpty, TaskAlt } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import {
  SaleSummarySettlementFilter,
  SaleSummarySettlementType,
} from "../contracts/viewContract/saleSummary/saleSummaryDetail.component";

type SaleSummaryFiltersProps = {
  settlementFilter: SaleSummarySettlementFilter;
  onSettlementFilterChange: (value: SaleSummarySettlementFilter) => void;
  settlementType: SaleSummarySettlementType;
  onSettlementTypeChange: (value: SaleSummarySettlementType) => void;
};

const buttonSx = { gap: 0.5, whiteSpace: "nowrap" };

/**
 * The settlements list filters, compact enough to sit next to its search
 * field. There is no "All" button: nothing pressed means no filter, and
 * pressing the active button again clears it.
 */
export const SaleSummaryFilters = ({
  settlementFilter,
  onSettlementFilterChange,
  settlementType,
  onSettlementTypeChange,
}: SaleSummaryFiltersProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ToggleButtonGroup
        exclusive
        color="primary"
        value={settlementFilter}
        onChange={(_event, value: SaleSummarySettlementFilter | null) =>
          onSettlementFilterChange(value ?? "all")
        }
        aria-label={t("Contracts") + ":"}
      >
        <Tooltip title={t("Fully settled only")}>
          <ToggleButton value="fully_settled" sx={buttonSx}>
            <TaskAlt fontSize="small" />
            {t("Fully settled")}
          </ToggleButton>
        </Tooltip>
        <Tooltip title={t("Not settled only")}>
          <ToggleButton value="not_settled" sx={buttonSx}>
            <HourglassEmpty fontSize="small" />
            {t("Not settled")}
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>

      <ToggleButtonGroup
        exclusive
        color="primary"
        value={settlementType}
        onChange={(_event, value: SaleSummarySettlementType | null) =>
          onSettlementTypeChange(value ?? "all")
        }
        aria-label={t("Settlement type") + ":"}
      >
        <Tooltip title={t("Rent only")}>
          <ToggleButton value="rent" sx={buttonSx}>
            <EventRepeat fontSize="small" />
            {t("Rent")}
          </ToggleButton>
        </Tooltip>
        <Tooltip title={t("Sale only")}>
          <ToggleButton value="sale" sx={buttonSx}>
            <AttachMoney fontSize="small" />
            {t("Sale")}
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </>
  );
};
